import React from 'react';
import classNames, { Argument } from 'classnames';

import Icon, { ICONS, COLORS } from './icon';

interface ButtonCloseProps {
	onClick: () => void;
	moreClassNames?: Argument;
}

export default function ButtonClose(props: ButtonCloseProps) {
	return (
		<button
			className={classNames(
				'button-close transparent text-highlight padding-right-24px',
				props.moreClassNames,
			)}
			onClick={props.onClick}
		>
			<Icon name={ICONS.CLOSE} color={COLORS.DARK_GRAY_2} size={16} />
		</button>
	);
}
